import { render, staticRenderFns } from "./RelatorioLogAcessosRetrato.vue?vue&type=template&id=a2c91116"
import script from "./RelatorioLogAcessosRetrato.vue?vue&type=script&lang=js"
export * from "./RelatorioLogAcessosRetrato.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLogAcessosRetrato.vue?vue&type=style&index=0&id=a2c91116&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports